export default __webpack_public_path__ + "static/media/awp-logo.bdb1c68e.png";